export default __webpack_public_path__ + "static/media/diego.8e7e5bc4.jpg";